// extracted by mini-css-extract-plugin
export default {"input-box":"Dropdown_input-box__z2Zl4","label":"Dropdown_label__ElMS4","input":"Dropdown_input__Q-n0s"};